<template>
  <b-nav-item-dropdown right no-caret>
    <template #button-content>
      <div class="account-btn pl-3 pr-2">
        {{ $store.state.user.name }}
        <img src="/static/img/logo-icon.svg" alt="avatar" class="img-avatar" />
      </div>
    </template>

    <b-dropdown-header tag="div" class="text-center">
      <strong>{{ $store.state.user.name }}</strong>
    </b-dropdown-header>
    <router-link to="/" tag="b-dropdown-item">
      <i class="icon-home"></i> Dashboard
    </router-link>
    <router-link :to="{ name: 'Account' }" tag="b-dropdown-item">
      <i class="icon-user"></i> My Account
    </router-link>
    <!-- TODO: add Manage Team -->
    <b-dropdown-item @click="logUserOut">
      <i class="fa fa-lock"></i> Log Out
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
export default {
  name: "header-dropdown-accnt",

  methods: {
    async logUserOut() {
      try {
        await this.$store.dispatch("user/logout");
        this.$router.push("/login");
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss">
.nav-item.b-nav-dropdown > a {
  padding: 0;
}

.account-btn {
  border: 1px solid;
  border-radius: 20px;
  display: inline-block;
  color: $gray-600;
}

.img-avatar {
  padding: 5px;
}
</style>
